import Swiper from "swiper";
console.log( 'Hello World! (from create-block-event-slider block)' );
document.addEventListener('DOMContentLoaded', () => {
	const swiperContainers = document.querySelectorAll('.event-slider');
	swiperContainers.forEach((container) => {
		new Swiper(container, {

			breakpoints:{
				0:{
					slidesPerView: 1.2,
					spaceBetween: 18,
				},
				768:{
					slidesPerView: 2.5,
					spaceBetween: 25,
				},
				1024:{
					slidesPerView: 3.2,
					spaceBetween: 30,
				},
				1440:{
					spaceBetween: 35,
					slidesPerView: 3.2,
				},
				1600:{
					slidesPerView: 3.2,
					spaceBetween:20,
				}

			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
		});
	});
});

